var LogoutLayoutComponent = /** @class */ (function () {
    function LogoutLayoutComponent() {
    }
    return LogoutLayoutComponent;
}());
export { LogoutLayoutComponent };
